import { Card, Col, Row, Typography } from "antd";
import { Link } from "react-router-dom";
import { LoginContainer } from "../../components";
import AppFooter from "../../constants/layout/footer";

const { Text } = Typography;

const AcceptableUse = () => {
    return (
        <LoginContainer>
            <Row justify="center" align="middle">
                <Card style={{ width: "90%" }}>
                    <Row style={{ marginTop: "2em" }}>
                        <Col span={4}></Col>
                        <Col span={16}>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                <Text style={{ fontSize: "2.5em", fontWeight: "bolder" }}>
                                    Appbox Acceptable Use Policy
                                </Text>
                            </Row>
                            <Row
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginBottom: "1em",
                                }}>
                                <Text style={{ fontSize: "0.8em", fontWeight: "lighter" }}>
                                    Last Modified: October 4, 2023
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    Your use of the Service is subject to this Acceptable Use
                                    Policy. If you are found to be in violation of our policies at
                                    any time, as determined by Appbox in its sole discretion, we may
                                    warn you or suspend or terminate your account. Please note that
                                    we may change our Acceptable Use Policy at any time, and
                                    pursuant to the{" "}
                                    <Link to={"/terms_of_service"}>Appbox Terms of Service</Link>
                                    (”Terms”), it is your responsibility to keep up-to-date with and
                                    adhere to the policies posted here. All capitalized terms used
                                    herein have the meanings stated in the Terms, unless stated
                                    otherwise. You agree not to engage in any of the following
                                    prohibited activities:{" "}
                                    <ol>
                                        <li>
                                            copying, distributing, or disclosing any part of the
                                            Service in any medium, including without limitation by
                                            any automated or non-automated “scraping”;
                                        </li>
                                        <li>
                                            using any automated system, including without limitation
                                            “robots,” “spiders,” “offline readers,” etc., to access
                                            the Service in a manner that sends more request messages
                                            to the Appbox servers than a human can reasonably
                                            produce in the same period of time by using a
                                            conventional on-line web browser (except that Appbox
                                            grants the operators of public search engines revocable
                                            permission to use spiders to copy publicly available
                                            materials from the Service for the sole purpose of and
                                            solely to the extent necessary for creating publicly
                                            available searchable indices of the materials, but not
                                            caches or archives of such materials);
                                        </li>
                                        <li>
                                            transmitting spam, chain letters, or other unsolicited
                                            email;
                                        </li>
                                        <li>
                                            attempting to interfere with, compromise the system
                                            integrity or security or decipher any transmissions to
                                            or from the servers running the Service;
                                        </li>
                                        <li>
                                            taking any action that imposes, or may impose at our
                                            sole discretion an unreasonable or disproportionately
                                            large load on our infrastructure;
                                        </li>
                                        <li>
                                            uploading invalid data, viruses, worms, or other
                                            software agents through the Service;
                                        </li>
                                        <li>
                                            collecting or harvesting any personally identifiable
                                            information, including account names, from the Service;
                                        </li>
                                        <li>
                                            reselling, renting or leasing the Service to your own
                                            customers directly;
                                        </li>
                                        <li>
                                            impersonating another person or otherwise
                                            misrepresenting your affiliation with a person or
                                            entity, conducting fraud, hiding or attempting to hide
                                            your identity;
                                        </li>
                                        <li>interfering with the proper working of the Service;</li>
                                        <li>
                                            accessing any content on the Service through any
                                            technology or means other than those provided or
                                            authorized by the Service;
                                        </li>
                                        <li>using the Service to mine cryptocurrencies;</li>
                                        <li>
                                            using the Service to bypass network restrictions or to
                                            access services that are not publicly available,
                                            including the use of proxy servers;
                                        </li>
                                        <li>
                                            bypassing the measures we may use to prevent or restrict
                                            access to the Service, including without limitation
                                            features that prevent or restrict use or copying of any
                                            content or enforce limitations on use of the Service or
                                            the content therein;
                                        </li>
                                        <li>
                                            or engaging in any unlawful or objectionable activities
                                            on the Service, as determined in our sole discretion.
                                        </li>
                                    </ol>
                                </Text>
                            </Row>
                        </Col>
                        <Col span={4}></Col>
                    </Row>
                </Card>
            </Row>
            <AppFooter />
        </LoginContainer>
    );
};
export { AcceptableUse };
